
  const learningDetailsStyle = {
    root:{
      direction:"ltr",
      textAlign:"left"
    },
    div:{
      padding:"20px",
      paddingBottom:"40px",
      marginTop:"30px"
    },

    chipMargin:{
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      '& > *': {
        margin: "3px",
      },
  },
    '@media (max-width: 600px)': {
      chipMargin:{
     marginTop: "0px !important", 
     marginLeft: "0px !important",
     "&  *":{
      whiteSpace: "normal !important",
      height:"unset !important",
      overflowWrap: "anywhere"
     }
    }
    },
    center: {
      textAlign: "center"
    },
    paper:{
      marginTop:"20px",
      borderColor:"#eaeaea"
    },
    formInput:{
      marginTop:"20px",
      marginLeft:"20px",
      display: "inline-block",
    },
    limitWidthMedium:{
      maxWidth:"170px"
    },
    limitWidthSmall:{
      maxWidth:"150px"
    },
    formControl: {
      minWidth: 120,
    },
    en:{
      direction:"rtl",
      textAlign:"right"
    },
    green:{
color:"green"
    },
  
    save:{
      textAlign:"center",
      marginBottom:"20px"
    },
    pointer:{
      cursor:'pointer',
      '&:hover':{
        color: 'red',
      }
    },
    tableContainer:{
      marginTop:"20px"
    },
    table: {
      minWidth: 650,
    },
    header:{
      color:"red"
    },
  };
  export default learningDetailsStyle;